/* ===== Account Page UI ===== */
import { $ } from '../utils/helpers.js?v=83.58';
import { getCurrentUser } from '../services/auth.js?v=83.58';
import { getCurrentSettings, loadSettings } from '../services/settings.js?v=83.58';
import { showSnackbar } from '../utils/ui.js?v=83.58';
import { auth } from '../config/firebase.js?v=83.58';
import { validateEmail, validateCUI, validateCompanyName } from '../utils/validation.js?v=83.58';
import { logger } from '../utils/logger.js?v=83.58';
import { sanitizeImageSrc } from '../utils/url.js?v=83.58';
import { normalizePublicSlugClient } from '../services/public-client.js?v=83.58';
// Firebase auth functions are available via firebase global or auth object

// Clean company name by removing legal prefixes/suffixes
export function cleanCompanyName(companyName) {
  if (!companyName || typeof companyName !== 'string') {
    return 'SpressJoy';
  }
  
  let cleaned = companyName.trim();
  
  // Remove legal prefixes/suffixes (case-insensitive, with or without dots)
  const legalTerms = [
    /\bSC\b\.?/gi,
    /\bS\.C\.\b/gi,
    /\bSRL\b\.?/gi,
    /\bS\.R\.L\.\b/gi,
    /\bSA\b\.?/gi,
    /\bS\.A\.\b/gi
  ];
  
  legalTerms.forEach(term => {
    cleaned = cleaned.replace(term, '');
  });
  
  // Clean up extra whitespace
  cleaned = cleaned.replace(/\s+/g, ' ').trim();
  
  // If empty after cleaning, return default
  return cleaned || 'SpressJoy';
}

// Update admin page header: nume locație + status abonament
export function updateAdminPageBrand() {
  const brandEl = document.getElementById('adminPageBrand');
  if (brandEl) {
    const settings = getCurrentSettings();
    const companyName = settings?.companyName || '';
    brandEl.textContent = cleanCompanyName(companyName);
  }
  updateAccountBillingBadge();
}

function firestoreTsToMillis(t) {
  if (t == null) return null;
  if (typeof t.toMillis === 'function') return t.toMillis();
  if (typeof t.toDate === 'function') return t.toDate().getTime();
  if (typeof t.seconds === 'number') {
    return t.seconds * 1000 + Math.floor((t.nanoseconds || 0) / 1e6);
  }
  if (typeof t._seconds === 'number') {
    return t._seconds * 1000 + Math.floor((t._nanoseconds || 0) / 1e6);
  }
  return null;
}

const BILLING_BADGE_ELEMENT_IDS = ['accountBillingStatusBadge'];

function paintBillingBadgeElement(el, hidden, text, variant) {
  if (!el) return;
  if (hidden) {
    el.hidden = true;
    el.textContent = '';
    el.className = 'account-billing-badge';
    return;
  }
  el.textContent = text;
  el.className = `account-billing-badge account-billing-badge--${variant}`;
  el.hidden = false;
}

function paintAdminBillingSubtitle(el, hidden, text, variant) {
  if (!el) return;
  if (hidden) {
    el.hidden = true;
    el.textContent = '';
    el.className = 'dashboard-subtitle dashboard-billing-subtitle';
    return;
  }
  el.textContent = text;
  el.className = `dashboard-subtitle dashboard-billing-subtitle dashboard-billing-subtitle--${variant}`;
  el.hidden = false;
}

/** Badge cont admin + pagina Cont: DEMO / activ / blocat / expirat */
export function updateAccountBillingBadge() {
  const settings = getCurrentSettings();
  let hidden = true;
  let text = '';
  let variant = 'active';

  if (settings && typeof settings === 'object') {
    let status = String(settings.accountStatus || '').toLowerCase();
    const trialEnd = firestoreTsToMillis(settings.trialEndsAt);
    const subEnd = firestoreTsToMillis(settings.subscriptionEndsAt);

    if (!status && trialEnd != null) {
      status = Date.now() < trialEnd ? 'demo' : 'expired';
    } else if (!status && subEnd != null) {
      status = 'active';
    }

    if (status || trialEnd != null || subEnd != null) {
      if (status === 'blocked') {
        text = 'Cont blocat — contactează suportul';
        variant = 'blocked';
        hidden = false;
      } else if (status === 'expired') {
        text = 'Perioada de acces a expirat';
        variant = 'expired';
        hidden = false;
      } else if (status === 'demo') {
        if (trialEnd != null) {
          const days = Math.max(0, Math.ceil((trialEnd - Date.now()) / 86400000));
          text =
            days === 0
              ? 'Demo · expiră astăzi'
              : days === 1
                ? 'Demo · încă 1 zi rămasă'
                : `Demo · încă ${days} zile rămase`;
        } else {
          text = 'Perioadă demo activă';
        }
        variant = 'demo';
        hidden = false;
      } else if (status === 'active') {
        if (subEnd != null) {
          const days = Math.ceil((subEnd - Date.now()) / 86400000);
          if (days <= 0) {
            text = 'Abonament expirat';
            variant = 'expired';
          } else {
            text =
              days === 1
                ? 'Abonament · încă 1 zi rămasă'
                : `Abonament · încă ${days} zile rămase`;
            variant = 'active';
          }
        } else {
          text = 'Abonament activ';
          variant = 'active';
        }
        hidden = false;
      }
    }
  }

  for (const id of BILLING_BADGE_ELEMENT_IDS) {
    paintBillingBadgeElement(document.getElementById(id), hidden, text, variant);
  }
  paintAdminBillingSubtitle(document.getElementById('adminBillingSubtitle'), hidden, text, variant);
}

// Toggle user dropdown
export function toggleUserDropdown() {
  const dropdown = document.getElementById('userDropdown');
  const dropdownAccount = document.getElementById('userDropdownAccount');
  const dropdownAdmin = document.getElementById('userDropdownAdmin');
  
  if (dropdown) {
    dropdown.classList.toggle('active');
  }
  if (dropdownAccount) {
    dropdownAccount.classList.toggle('active');
  }
  if (dropdownAdmin) {
    dropdownAdmin.classList.toggle('active');
  }
  
  // Close dropdown when clicking outside
  document.addEventListener('click', function closeDropdownOnOutsideClick(e) {
    const avatarBtn = document.getElementById('userAvatarBtn');
    const avatarBtnAdmin = document.getElementById('userAvatarBtnAdmin');
    if (!e.target.closest('.user-avatar-container') && !e.target.closest('.user-dropdown')) {
      if (dropdown) dropdown.classList.remove('active');
      if (dropdownAccount) dropdownAccount.classList.remove('active');
      if (dropdownAdmin) dropdownAdmin.classList.remove('active');
      document.removeEventListener('click', closeDropdownOnOutsideClick);
    }
  });
}

// Close user dropdown
export function closeUserDropdown() {
  const dropdown = document.getElementById('userDropdown');
  const dropdownAccount = document.getElementById('userDropdownAccount');
  const dropdownAdmin = document.getElementById('userDropdownAdmin');
  
  if (dropdown) dropdown.classList.remove('active');
  if (dropdownAccount) dropdownAccount.classList.remove('active');
  if (dropdownAdmin) dropdownAdmin.classList.remove('active');
}

// Load account settings into form
export async function loadAccountSettings() {
  const currentUser = getCurrentUser();
  if (!currentUser) return;
  
  await loadSettings(currentUser.uid, true);
  const settings = getCurrentSettings();
  
  if ($('account_op_company')) {
    $('account_op_company').value = settings?.companyName || '';
  }
  if ($('account_op_brand')) {
    $('account_op_brand').value = settings?.locationMapName || '';
  }
  if ($('account_op_cui')) {
    $('account_op_cui').value = settings?.cui || '';
  }
  if ($('account_op_email')) {
    $('account_op_email').value = settings?.operatorEmail || '';
  }
  if ($('account_public_slug')) {
    $('account_public_slug').value = settings?.publicSlug || '';
  }
  updateAccountPublicUrlPreview();

  // Clear password fields
  if ($('account_old_password')) {
    $('account_old_password').value = '';
  }
  if ($('account_new_password')) {
    $('account_new_password').value = '';
  }

  updateAdminPageBrand();
}

// Save account settings
export async function saveAccountSettings() {
  const currentUser = getCurrentUser();
  if (!currentUser) {
    return showSnackbar('Nu ești logat');
  }
  
  try {
    showSnackbar('Salvez modificările...');
    
    const companyName = ($('account_op_company')?.value || '').trim();
    const cui = ($('account_op_cui')?.value || '').trim().toUpperCase();
    const operatorEmail = ($('account_op_email')?.value || '').trim().toLowerCase();
    const oldPassword = ($('account_old_password')?.value || '').trim();
    const newPassword = ($('account_new_password')?.value || '').trim();
    
    // Validate company name
    const companyValidation = validateCompanyName(companyName);
    if (!companyValidation.valid) {
      throw new Error(companyValidation.message);
    }
    
    // Validate CUI if provided
    if (cui) {
      if (!validateCUI(cui)) {
        throw new Error('CUI invalid (format: RO12345678 sau 12345678).');
      }
    }
    
    // Validate email if provided
    if (operatorEmail) {
      if (!validateEmail(operatorEmail)) {
        throw new Error('Email invalid.');
      }
    }
    
    const slugRaw = ($('account_public_slug')?.value || '').trim();
    let publicSlugField = undefined;
    if (slugRaw === '') {
      publicSlugField = undefined; // linkul nu se șterge din formularul de cont
    } else {
      const ns = normalizePublicSlugClient(slugRaw);
      if (ns === null) {
        throw new Error('Slug invalid: 3–48 caractere, litere mici, cifre și cratimă (ex: green-pub).');
      }
      publicSlugField = ns;
    }

    // Update company data
    const updateData = {
      companyName: companyValidation.value,
      cui,
      operatorEmail,
      publicSlug: publicSlugField
    };
    // denumirea comercială (ex. „Anturaj”) = numele de pe pagina din QR; goală → se folosește numele firmei
    if ($('account_op_brand')) updateData.locationMapName = ($('account_op_brand').value || '').trim().slice(0, 80);
    
    // Update password if provided
    if (oldPassword && newPassword) {
      if (newPassword.length < 8) {
        throw new Error('Parola nouă trebuie să aibă minim 8 caractere.');
      }
      
      // Reauthenticate user
      const cred = firebase.auth.EmailAuthProvider.credential(
        currentUser.email,
        oldPassword
      );
      
      await currentUser.reauthenticateWithCredential(cred);
      
      // Update password
      await currentUser.updatePassword(newPassword);
      
      showSnackbar('Parola a fost schimbată cu succes');
    } else if (newPassword && !oldPassword) {
      throw new Error('Trebuie să introduci parola actuală pentru a schimba parola.');
    }
    
    // Save to Firestore via Cloud Function
    const { saveCampaignSettingsBackend } = await import('../services/backend.js?v=83.58');
    await saveCampaignSettingsBackend(updateData);
    await loadSettings(currentUser.uid, true);
    updateAccountPublicUrlPreview();

    // Update admin page brand if on admin page
    updateAdminPageBrand();

    // Note: Company/CUI/Email fields are no longer in admin panel - they're only in Account page
    
    // Clear password fields
    if ($('account_old_password')) $('account_old_password').value = '';
    if ($('account_new_password')) $('account_new_password').value = '';
    
    showSnackbar('Modificările au fost salvate ✔');
  } catch (error) {
    logger.error('[account] Error saving settings:', error);
    showSnackbar('Eroare: ' + (error.message || 'Nu s-au putut salva modificările'));
  }
}

export function updateAccountPublicUrlPreview() {
  const input = $('account_public_slug');
  const prev = $('account_public_url_preview');
  if (!prev) return;
  const t = (input?.value || '').trim().toLowerCase();
  if (!t) {
    prev.textContent = '—';
    return;
  }
  try {
    prev.textContent = `${window.location.origin}/m/${encodeURIComponent(t)}`;
  } catch {
    prev.textContent = `${window.location.origin}/m/${t}`;
  }
}

/** Salvează doar slug-ul public (fără parolă / date operator). */
export async function saveAccountPublicSlug() {
  const currentUser = getCurrentUser();
  if (!currentUser) {
    return showSnackbar('Nu ești logat');
  }
  try {
    const slugRaw = ($('account_public_slug')?.value || '').trim().toLowerCase();
    const oldSlug = String(getCurrentSettings()?.publicSlug || '').trim();
    if (slugRaw === '') {
      throw new Error('Linkul nu poate fi gol.');
    }
    const ns = normalizePublicSlugClient(slugRaw);
    if (ns === null) {
      throw new Error('Link invalid: 3–48 caractere, litere mici, cifre și cratimă (ex: green-pub).');
    }
    if (ns === oldSlug) {
      return showSnackbar('Linkul e deja acesta.');
    }
    const publicSlugField = ns;
    showSnackbar('Salvez linkul...');
    const { saveCampaignSettingsBackend } = await import('../services/backend.js?v=83.58');
    await saveCampaignSettingsBackend({ publicSlug: publicSlugField });
    await loadSettings(currentUser.uid, true);
    updateAccountPublicUrlPreview();
    showSnackbar(oldSlug ? 'Link schimbat ✔ Descarcă și tipărește noul cod QR — cel vechi nu mai funcționează.' : 'Link salvat ✔', 'success');
  } catch (error) {
    logger.error('[account] saveAccountPublicSlug:', error);
    const msg = error?.message || error?.details || 'Nu s-a putut salva';
    showSnackbar('Eroare: ' + msg);
  }
}

/** Descarcă PNG QR pentru URL-ul locației publice. */
export async function downloadAccountLocationQr() {
  const raw = ($('account_public_slug')?.value || '').trim();
  const slug = normalizePublicSlugClient(raw);
  if (!slug) {
    return showSnackbar('Setează un slug valid și salvează-l înainte (3–48 caractere).');
  }
  const settings = getCurrentSettings();
  if (String(settings?.publicSlug || '').toLowerCase() !== slug) {
    return showSnackbar('Salvează mai întâi slug-ul cu „Salvează slug public”.');
  }
  try {
    const url = `${window.location.origin}/m/${encodeURIComponent(slug)}`;
    const QR = await import('https://cdn.jsdelivr.net/npm/qrcode@1.5.3/+esm');
    const dataUrl = await QR.toDataURL(url, { width: 512, margin: 2, errorCorrectionLevel: 'M' });
    const a = document.createElement('a');
    a.href = dataUrl;
    a.download = `spressjoy-locatie-${slug}.png`;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
    showSnackbar('QR descărcat');
  } catch (error) {
    logger.error('[account] downloadAccountLocationQr:', error);
    showSnackbar('Nu s-a putut genera QR. Verifică conexiunea.');
  }
}

// Toggle account section (similar to admin sections)
export function toggleAccountSection(sectionId, event) {
  // Guard: ignore clicks on buttons and inputs inside
  if (event && event.target) {
    if (event.target.closest('button') || event.target.closest('input') || event.target.closest('select') || event.target.closest('textarea')) {
      return; // Don't toggle if click is on interactive element
    }
  }

  const section = document.querySelector(`.admin-section[data-section="${sectionId}"]`);
  if (!section) return;

  const isExpanded = section.classList.contains('expanded');
  
  if (isExpanded) {
    section.classList.remove('expanded');
  } else {
    section.classList.add('expanded');
  }

  // Save state to localStorage
  const storageKey = 'sj_account_sections';
  try {
    const saved = localStorage.getItem(storageKey);
    const state = saved ? JSON.parse(saved) : {};
    state[sectionId] = !isExpanded;
    localStorage.setItem(storageKey, JSON.stringify(state));
  } catch (e) {
    logger.warn('Failed to save account sections state:', e);
  }
}

// Initialize account sections on page load
export function initAccountSections() {
  const storageKey = 'sj_account_sections';
  try {
    const saved = localStorage.getItem(storageKey);
    const state = saved ? JSON.parse(saved) : {};
    
    document.querySelectorAll('.admin-section[data-section^="account-"]').forEach(section => {
      const sectionId = section.getAttribute('data-section');
      if (!sectionId) return;
      
      // Apply saved state
      if (state[sectionId]) {
        section.classList.add('expanded');
      }
    });

    const slugInput = document.getElementById('account_public_slug');
    if (slugInput && !slugInput.dataset.previewBound) {
      slugInput.dataset.previewBound = '1';
      slugInput.addEventListener('input', () => updateAccountPublicUrlPreview());
    }
  } catch (e) {
    logger.warn('Failed to load account sections state:', e);
  }
  
  // Initialize local background (async)
  initAccountBackground().catch(() => {});
  
  // Apply local background on page load
  import('../utils/helpers.js?v=83.58').then(m => m.applyLocalBackground()).catch(() => {});
}

// Local background management pentru accountPage și adminPage (fără backend)
export async function initAccountBackground() {
  const bgInput = document.getElementById('accountBgUpload');
  const bgPreview = document.getElementById('accountBgPreview');
  
  if (!bgInput || !bgPreview) return;
  
  // Încarcă imaginea salvată din localStorage
  const savedBg = localStorage.getItem('accountPageBackground');
  if (savedBg) {
    const { applyLocalBackground } = await import('../utils/helpers.js?v=83.58');
    applyLocalBackground();
    // XSS-safe rendering: Use DOM API instead of innerHTML
    const safeUrl = sanitizeImageSrc(savedBg);
    if (safeUrl) {
      bgPreview.replaceChildren();
      const img = document.createElement('img');
      img.src = safeUrl;
      img.style.width = '120px';
      img.style.borderRadius = '10px';
      img.style.border = '1px solid #eee';
      bgPreview.appendChild(img);
    } else {
      bgPreview.replaceChildren();
    }
  }
  
  // Handle file upload
  bgInput.addEventListener('change', async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    if (!file.type.startsWith('image/')) {
      showSnackbar('Selectează o imagine validă', 'error');
      return;
    }
    
    if (file.size > 5 * 1024 * 1024) {
      showSnackbar('Imaginea este prea mare (max 5MB)', 'error');
      return;
    }
    
    const reader = new FileReader();
    reader.onload = async (event) => {
      const dataUrl = event.target.result;
      localStorage.setItem('accountPageBackground', dataUrl);
      const { applyLocalBackground } = await import('../utils/helpers.js?v=83.58');
      applyLocalBackground();
      // XSS-safe rendering: Use DOM API instead of innerHTML
      const safeUrl = sanitizeImageSrc(dataUrl);
      if (safeUrl) {
        bgPreview.replaceChildren();
        const img = document.createElement('img');
        img.src = safeUrl;
        img.style.width = '120px';
        img.style.borderRadius = '10px';
        img.style.border = '1px solid #eee';
        bgPreview.appendChild(img);
      } else {
        bgPreview.replaceChildren();
      }
      showSnackbar('Fundal salvat local ✔');
    };
    reader.readAsDataURL(file);
  });
}

// Șterge background-ul local
export async function clearAccountBackground() {
  localStorage.removeItem('accountPageBackground');
  const { applyLocalBackground } = await import('../utils/helpers.js?v=83.58');
  applyLocalBackground();
  const bgPreview = document.getElementById('accountBgPreview');
  if (bgPreview) bgPreview.replaceChildren();
  const bgInput = document.getElementById('accountBgUpload');
  if (bgInput) bgInput.value = '';
  showSnackbar('Fundal șters');
}

// ✅ Check for app update and trigger SKIP_WAITING
export async function checkAppUpdate() {
  if (!('serviceWorker' in navigator)) {
    return showSnackbar('Service Worker nu este disponibil în acest browser');
  }

  try {
    showSnackbar('Verific actualizări...');

    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) {
      return showSnackbar('Service Worker nu este înregistrat');
    }

    // Check for updates
    await registration.update();

    // Check if there's a waiting service worker
    if (registration.waiting) {
      // There's an update waiting - trigger SKIP_WAITING
      showSnackbar('Actualizare disponibilă. Se reîncarcă aplicația...');

      // Listen for controllerchange event (new SW becomes active)
      let reloaded = false;
      const reloadOnce = () => {
        if (!reloaded) {
          reloaded = true;
          window.location.reload();
        }
      };

      navigator.serviceWorker.addEventListener('controllerchange', reloadOnce, { once: true });

      // Send SKIP_WAITING message to waiting service worker
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });

      // Fallback: reload after 2 seconds if controllerchange doesn't fire
      setTimeout(() => {
        if (!reloaded) {
          reloadOnce();
        }
      }, 2000);
    } else if (registration.installing) {
      // SW is installing - wait for it to become waiting
      showSnackbar('Actualizare în curs de instalare. Încearcă din nou în câteva secunde.');
    } else {
      // No update available
      showSnackbar('Ești pe ultima versiune');
    }
  } catch (error) {
    logger.error('[account] Error checking update:', error);
    showSnackbar('Eroare la verificarea actualizărilor: ' + (error.message || 'Eroare necunoscută'));
  }
}

// ✅ Reset app cache (Caches API only, keeps localStorage)
export async function resetAppCache() {
  // Confirmation dialog
  const confirmed = confirm(
    'Ești sigur că vrei să ștergi cache-ul aplicației?\n\n' +
    'Această acțiune va:\n' +
    '• Șterge cache-ul Service Worker (Caches API)\n' +
    '• Reîncărca aplicația\n\n' +
    'NU va șterge:\n' +
    '• Datele salvate local (localStorage)\n' +
    '• Setările contului\n' +
    '• Datele din Firestore\n\n' +
    'Folosește această opțiune doar pentru testare/debugging.'
  );

  if (!confirmed) return;

  try {
    showSnackbar('Se șterge cache-ul...');

    // Clear all caches (Caches API only)
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames.map(cacheName => caches.delete(cacheName))
      );
      logger.log('[account] Cleared caches:', cacheNames);
    }

    // Unregister service worker (if exists)
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        await registration.unregister();
        logger.log('[account] Unregistered service worker');
      }
    }

    showSnackbar('Cache șters. Se reîncarcă aplicația...');

    // Reload after a short delay
    setTimeout(() => {
      window.location.reload();
    }, 500);
  } catch (error) {
    logger.error('[account] Error resetting cache:', error);
    showSnackbar('Eroare la resetarea cache-ului: ' + (error.message || 'Eroare necunoscută'));
  }
}

// Make functions available globally
window.toggleUserDropdown = toggleUserDropdown;
window.closeUserDropdown = closeUserDropdown;
window.saveAccountSettings = saveAccountSettings;
window.toggleAccountSection = toggleAccountSection;
window.clearAccountBackground = clearAccountBackground;
window.checkAppUpdate = checkAppUpdate;
window.resetAppCache = resetAppCache;